import { create } from "zustand";

const playerInfoStore = create((set) => ({
  playerInfos: {}, // Lưu trữ tất cả các player và config của họ

  // Cập nhật toàn bộ config của một player
  updatePlayer: (playerId, newInfo) =>
    set((state) => ({
      playerInfos: {
        ...state.playerInfos,
        [playerId]: newInfo, // Cập nhật toàn bộ config của player
      },
    })),
}));

export default playerInfoStore;
